import React, { useEffect, useRef } from 'react';
import { CloseIcon, SearchIcon, SpinnerIcon } from '../../../assets/svg';

const InputWithSearch = ({
    setSearch,
    placeholder = 'Search...',
    className,
    onChange,
    onClear = undefined,
    mainStyle,
    OnBlur,
    isLoading = false,
    inputClassName,
    ...props
}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }

        if (props?.search) {
            inputRef.current.value = props?.search;
        }
    }, [inputRef, props?.search]);

    const onCrossClick = () => {
        onClear ? onClear() : setSearch('');
        if (inputRef?.current) inputRef.current.value = '';
    };

    return (
        <div
            className={`custom-search-box d-flex align-items-center justify-content-start ${className}`}
            style={mainStyle}
        >
            <span className='bg-white p-0 border-0 d-flex align-items-center'>
                <SearchIcon />
            </span>
            {(props.search || inputRef?.current?.value) && !isLoading && (
                <button
                    className=' position-absolute border-0 bg-transparent text-danger'
                    onClick={onCrossClick}
                    title='Clear Search'
                    style={{ cursor: 'pointer', right: '0.75rem' }}
                >
                    <CloseIcon size={12} />
                </button>
            )}
            {isLoading && (
                <span className=' position-absolute' style={{ right: '0.75rem' }}>
                    <SpinnerIcon />
                </span>
            )}
            <input
                ref={inputRef}
                type='text'
                maxLength={40}
                className={`search-area border-0 w-100 py-1 pe-4 ${inputClassName}`}
                placeholder={placeholder}
                onChange={onChange ? onChange : (e) => setSearch(e.target.value)}
                onKeyDown={(e) =>
                    e.key === 'Escape' ? (onClear ? onClear(e) : setSearch('')) : null
                }
                onBlur={OnBlur}
                {...props}
            />
        </div>
    );
};

export default InputWithSearch;
